import { NUMBER_TYPE } from '@/utils/constants';

export default {
  setNumber: 'Ya puedes pagar o activar tu Débito Automático Mensual de tu línea móvil y Claro Hogar de manera fácil y segura.',
  app: 'https://play.google.com/store/apps/details?id=com.recarga.saldo1.claro.sv.app',
  homeInstructions: `- Si tu servicio es paquetizado selecciona "Línea Fija"
  - Si tu servicio es único selecciona "Servicios únicos"`,
  profiles: [
    {
      key: NUMBER_TYPE[1],
      checkboxLabel: 'Móvil',
      inputLabel: 'Digita tu número telefónico'
    },
    {
      key: NUMBER_TYPE[0],
      checkboxLabel: 'Línea Fija',
      inputLabel: 'Digita el número de tu línea fija'
    },
    {
      key: NUMBER_TYPE[3],
      checkboxLabel: 'Servicios únicos',
      inputLabel: 'Digita tu número de Servicio: Ejemplo: DTH000000, CTV000000, HFCI00000'
    }
  ]
};
